import React from 'react';

class Globals extends React.Component {

    static userInfo = {
        id: "",
        userName: "",
        isLoggedIn: false,
        userType: "",
        jobShopDivision: "",
        userMenu: [],
        webcmRoles: '',
        bearer: "",
        email: "",
        emailpassword: "",
        imapSentFolder: "",
        userQueueAccess: ""
    };

    static customers = [];

    static defaultLoadingMessage = "Use the search bar above";
    static customersLoadingMessage = "Use the search bar above";

    static postdataJss = {};
    static postdataJst = {};

    static findByRoute = (o, route) => {
        if (o.route === route) {
            return o;
        }
        var result, p;
        for (p in o) {
            if (o.hasOwnProperty(p) && typeof o[p] === 'object') {
                result = Globals.findByRoute(o[p], route);
                if (result) {
                    return result;
                }
            }
        }
        return result;
    }

}

export default Globals;
